import { render } from "./PFD.vue?vue&type=template&id=26f0231c&scoped=true&ts=true"
import script from "./PFD.vue?vue&type=script&lang=ts"
export * from "./PFD.vue?vue&type=script&lang=ts"

import "./PFD.vue?vue&type=style&index=0&id=26f0231c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f0231c"]])

export default __exports__